export default __webpack_public_path__ + "assets/northernireland-flag.png";